import 'rc-slider/assets/index.css';
import '../css/app.css';
import './bootstrap';
import './fonts/line-awesome-1.3.0/css/line-awesome.css';
import './styles/index.scss';
import { RouteContext } from '@/Hooks/useRoute';
import { createInertiaApp } from '@inertiajs/react';
// Sentry initialization should be imported first!
import './lib/instrument.js';
//import { ModalStackProvider, ModalRoot } from '@inertiaui/modal-react'
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers';
//import { createRoot } from 'react-dom/client';
import { createRoot, hydrateRoot } from 'react-dom/client';
import { Toaster } from 'sonner';

const appName =
  window.document.getElementsByTagName('title')[0]?.innerText || 'Más Pisto';

createInertiaApp({
  title: (title) => `${title} - ${appName}`,
  progress: {
    color: '#30951c',
    showSpinner: true,
  },
  resolve: (name) =>
    resolvePageComponent(
      `./Pages/${name}.tsx`,
      import.meta.glob('./Pages/**/*.tsx'),
    ),
  setup({ el, App, props }) {
    if (import.meta.env.SSR) {
      // Server side render
      hydrateRoot(
        el,
        <RouteContext.Provider value={(window as any).route}>
          <Toaster richColors position="top-center" />
          <App {...props} />
        </RouteContext.Provider>,
      );

      return;
    }

    // if (import.meta.env.DEV) {
    const root = createRoot(el);
    return root.render(
      // <StrictMode>
      // <ModalStackProvider>
      // <ModalRoot>
      <RouteContext.Provider value={(window as any).route}>
        <Toaster richColors position="top-center" />
        <App {...props} />
      </RouteContext.Provider>,
      // </ModalRoot>
      // </ModalStackProvider>,
      // </StrictMode>
    );
    // }
  },
});
